module.exports = __webpack_public_path__ + "static/media/19.1bdca226.jpg";